class NestedComments extends HTMLElement {
  constructor() {
    super()
    this.comments = this.querySelector('.nested-comments')
    this.formDetails = document.querySelector('#comment-form')
    this.formBtn = this.formDetails.querySelector('summary')
    this.clear = this.formDetails.querySelector('.btn--clear')
    this.overlay = this.formDetails.querySelector('.popup__overlay')
    this.settings = this.parseSettings(this.dataset)
    this.form = this.parseForm(document.querySelector('#comment_form'))
    this.loadMore = this.querySelector('.load-more')
    this.eventListeners()
  }
  parseSettings(data) {
    return {
      handle: data.handle,
      pagination: parseInt(data.pagination),
      loadCount: parseInt(data.loadCount),
      dateFormat: 'new',
      commentsCount: parseInt(data.commentsCount),
      commentsDepth: data.commentsDepth,
    }
  }
  parseForm(form) {
    return {
      elem: form,
      body: form.querySelector('#comment-form__body'),
      email: form.querySelector('#comment-form__email'), 
      name: form.querySelector('#comment-form__name'), 
      messages: form.querySelector('.form-help-messages'),
      content: form.querySelector('.content-textarea'),
      reply: form.querySelector('[data-reply-id]'),
      btn: form.querySelector('input[type="submit"]'), 
      article: form
        .getAttribute('action')
        .replace('/comments#comment_form', ''),
    }
  }
  resetForm(e) { 
    if(e.target === this.formBtn) {
      this.clearForm()
      this.form.reply.dataset.replyId = null
    }
  }
  validateForm(event) { 
    if(this.form.email.value === '' && this.form.name.value === '' && this.form.body.value == '') { 
      return
    } 
    if(!this.form.elem.checkValidity()) { 
      event.stopPropagation()
      this.form.btn.disabled = true
      this.form.elem.disabled = true
      if(!this.form.name.checkValidity()) { 
        this.form.email.setCustomValidity('');
        this.form.email.reportValidity();
      }
      if(!this.form.email.checkValidity()) { 
        this.form.email.setCustomValidity('');
        this.form.email.reportValidity();
      }
      if(!this.form.body.checkValidity() || this.form.content === '') { 
        this.form.content.parentElement.classList.add('form-field--error')
      } else { 
        this.form.content.parentElement.classList.remove('form-field--error')
      }
    } else { 
      this.form.content.parentElement.classList.remove('form-field--error')
      this.form.btn.disabled = false
      this.form.elem.disabled = false
    }
  }
  disableForm(event) { 
    this.validateForm(event)
    setTimeout(() => { 
      this.form.elem.reset()
      this.clearForm()
    },300)
  }
  eventListeners() { 
    this.addEventListener('click', this.onClick.bind(this))
    this.overlay.addEventListener('click', this.validateForm.bind(this))
    this.clear.addEventListener('click', this.clearForm.bind(this))
    this.form.content.addEventListener('input', () => this.updateFormBody())
    this.form.elem.addEventListener('submit', this.disableForm.bind(this))
  }
  clearForm() { 
    this.form.body.value = ''
    this.form.name.value = ''
    this.form.email.value = ''
    this.form.content.textContent = ''
    this.form.content.parentElement.classList.remove('form-field--error')
  }
  connectedCallback() {
    this.getComments()
  }
  onClick(event) {
    this.addReplyToForm(event)
    this.toggleReplies(event)
    this.resetForm.bind(event)
  }
  getComments() {
    const fetchRequests = []
    const comments = document.createElement('ul')

    const totalPages = Math.ceil(
      this.settings.commentsCount / this.settings.pagination
    )
    const fetchUrls = []

    for (let currentPage = 1; currentPage <= totalPages; currentPage++) {
      let pageParams = `&page=${currentPage}`
      let path = `/blogs/${this.settings.handle}`
      const fetchUrl = `${path}/?section_id=comments-api${pageParams}`
      fetchUrls.push(fetchUrl)
    }

    const fetchPromises = fetchUrls.map((url) => fetch(url))
    fetchRequests.push(Promise.all(fetchPromises))

    Promise.all(fetchRequests)
      .then((responsesArray) =>
        Promise.all(responsesArray.flat().map((response) => response.text()))
      )
      .then((texts) => {
        const fragment = document.createDocumentFragment()

        texts.forEach((text) => {
          const container = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.nested-comments')

          const allComments = container.querySelectorAll('.comments-comment')
          allComments.forEach((comment) => {
            fragment.appendChild(comment)
          })
        })
        comments.appendChild(fragment)
        this.renderComments(comments)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  sortByDate(objHTML) {
    const comments = Array.from(objHTML.querySelectorAll('.comments-comment'))
    comments.sort((a, b) => {
      const dateA = new Date(a.getAttribute('data-comment-date'))
      const dateB = new Date(b.getAttribute('data-comment-date'))
      if (this.settings.dateFormat === 'new') {
        return dateB - dateA
      } else {
        return dateA - dateB
      }
    })

    objHTML.innerHTML = ''
    comments.forEach((comment) => {
      objHTML.appendChild(comment)
    })

    return objHTML
  }
  renderComments(comments) {
    const sortedComments = this.sortByDate(comments)
    const nestedComments = this.createNestedComments(sortedComments)
    const fragment = document.createDocumentFragment()
    const commentsToLoad = Array.from(nestedComments.children)
    const firstChildren = commentsToLoad.slice(0, this.settings.loadCount)

    if (nestedComments.children.length > this.settings.loadCount) {
      fragment.append(...firstChildren)
      this.loadMore.classList.remove('hidden')
      this.loadMore.addEventListener('click', () =>
        this.loadNextComments(commentsToLoad, this.settings.loadCount)
      )
    } else {
      fragment.append(...nestedComments.children)
    }

    this.comments.appendChild(fragment)
  }
  loadNextComments(nestedComments, loadedComments) {
    const remainingComments = nestedComments.length - loadedComments
    const commentsToLoad = Math.min(this.settings.loadCount, remainingComments)
    const nextComments = nestedComments.slice(
      loadedComments,
      loadedComments + commentsToLoad
    )
    this.comments.append(...nextComments)
    loadedComments += commentsToLoad

    if (loadedComments >= nestedComments.length) {
      this.loadMore.classList.add('hidden')
    } else {
      this.loadMore.classList.remove('hidden')
      this.loadMore.addEventListener('click', () =>
        this.loadNextComments(nestedComments, loadedComments)
      )
    }
  }
  createNestedComments(objHTML) {
    const nestedComments = document.createElement('ul')
    const commentMap = {}

    const comments = Array.from(objHTML.children)

    comments.forEach((comment) => {
      const commentId = comment.getAttribute('data-comment-id')
      const replyId = comment.getAttribute('data-reply-id')

      if (!commentMap[commentId]) {
        commentMap[commentId] = { element: comment, children: [] }
      } else {
        commentMap[commentId].element = comment
      }

      if (!commentMap[replyId]) {
        commentMap[replyId] = { children: [] }
      }

      commentMap[replyId].children.push(commentMap[commentId])
    })

    this.createNestedStructure(nestedComments, commentMap[null].children)

    const liElements = nestedComments.querySelectorAll('li')
    liElements.forEach((liElement) => {
      const btnReplies = liElement.querySelector('.btn--replies')
      const repliesList = liElement.querySelector('.comments-comment__replies')
      if (btnReplies && repliesList) {
        btnReplies.classList.remove('hidden')
        const parent = btnReplies.parentNode
        parent.querySelector('.btn--reply').classList.add('circle-divider')
      }
    })

    return nestedComments
  }
  createNestedStructure(parentUl, comments) {
    comments.forEach((comment) => {
      const nestedLi = comment.element

      if (comment.children.length > 0) {
        const nestedUl = document.createElement('ul')
        nestedUl.classList.add('comments-comment__replies', 'hidden')
        nestedLi.appendChild(nestedUl)
        this.createNestedStructure(nestedUl, comment.children)
      }

      parentUl.appendChild(nestedLi)
    })
  }
  addReplyToForm(event) {
    const target = event.target
    if(target.classList.contains('btn--reply')) { 
      this.clearForm()
      let replyId = target.dataset.replyId
      this.formDetails.querySelector('summary').click()
      this.form.reply.setAttribute('data-reply-id',replyId)
    }
  }
  toggleReplies(event) {
    let target = event.target
    if (target.classList.contains('btn--replies')) {
      const parentLi = target.closest('.comments-comment')
      const repliesList = parentLi.querySelector('.comments-comment__replies')
      target.toggleAttribute('data-show')
      repliesList.classList.toggle('hidden')
    }
  }
  updateFormBody() {
    let updateBodyValue = this.form.content.textContent
    this.form.body.value = updateBodyValue
    if (updateBodyValue !== '') {
      this.form.content.parentElement
        .querySelector('label')
        .classList.add('hidden')
    } else {
      this.form.content.parentElement
        .querySelector('label')
        .classList.remove('hidden')
    }
    if (this.form.reply.dataset.replyId !== 'null') {
      let replyStr = `$reply-${this.form.reply.dataset.replyId}`
      updateBodyValue = `${this.form.content.textContent}${replyStr}`
      this.form.body.disabled = false
      this.form.btn.disabled = false
      this.form.body.value = ''
      this.form.body.value = updateBodyValue
    }
  }
}
customElements.define('nested-comments', NestedComments)
